// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2pnf0","notes":"Notes_notes__3NrK4"};